import type { useAuth } from "@/contexts/auth";

type AuthData = ReturnType<typeof useAuth>["data"];
type HomePageUser = NonNullable<AuthData>["user"];

export function getAuthUser(authData: AuthData): HomePageUser | null {
  return authData?.user ?? null;
}

export function getIsAuthenticated(user: HomePageUser | null): boolean {
  return user != null;
}

export function getUserId(user: HomePageUser | null): string | null {
  return user?.id ?? null;
}
